// extracted by mini-css-extract-plugin
export default {"fullScreen":"Loading_fullScreen__bAbSI","inline":"Loading_inline__bC+cO","hide":"Loading_hide__OBVJf"};